<div class="text-center d-flex flex-column w-100 success" style="border-radius: 5px">
  <div class="d-flex px-5 py-3 align-items-center">
    <img src="{{
        successful ? 'assets/svg/success-icon.svg' : 'assets/svg/failure.svg'
      }}" height="24" class="mt-3 mb-4 me-4" />
    <h1 class="title">
      {{ title }}
    </h1>
  </div>
</div>
<div class="my-3 position-absolute close-btn mx-3">
  <a [routerLink]="[]" class="text-dark" (click)="close()">
    <i class="bi bi-x-lg"></i>
  </a>
</div>
